import axios from 'axios';
import './App.css';
import MLBHomePage from './Pages/MLBHomePage';
import SportsHomePage from './Pages/SportsHomePage';
import EPLHomePage from './Pages/EPLHomePage';
import LayOut from './Pages/Components/LayOut';
import PageNotFoundPage from './Pages/Components/PageNotFoundPage';
import { createBrowserRouter, RouterProvider,} from 'react-router-dom';
import LoginPage from './Pages/Components/LoginPage';
import CreateAccountPage from './Pages/Components/CreateAccountPage';
import NFLHomePage from "./Pages/NFLHomePage";
import NBAHomePage from './Pages/NBAHomePage';
import WorldCupPage from './Pages/WorldCupPage';


const routes =[
  { 
    path:"/", element: <SportsHomePage />
  },{
    path: "*", element: <PageNotFoundPage />
  },{
    path: "/loginPage", element: <LoginPage />
  },{
    path: "/createAccountPage", element: <CreateAccountPage />
  },
  {
    element:<LayOut />,
    children: [{ 
      path: "/mlb/:date", element: <MLBHomePage />,
      loader: async function ({ params, request }){
        const url = new URL(request.url);
        const timezone = url.searchParams.get('tz'|| 'America/Los_Angeles');
        const response = await axios.get(`/api/mlb/${params.date}?timezone=${encodeURIComponent(timezone)}`);
        return response.data;
      },
      errorElement: <PageNotFoundPage />
      },{ 
      path: "/epl/:date", element: <EPLHomePage />,
      loader: async function({ params, request }){
        const url = new URL(request.url);
        const timezone = url.searchParams.get('tz') ?? "America/Los_Angeles";
        const response  = await axios.get(`/api/epl/${params.date}?timezone=${encodeURIComponent(timezone)}`);
        return response.data
  
      },
      errorElement: <PageNotFoundPage/>
    },
    { 
      path: "/wc2026/:date", element: <WorldCupPage />,
      loader: async function({ params, request }){
        const url = new URL(request.url);
        const timezone = url.searchParams.get('tz') ?? "America/Los_Angeles";
        const response  = await axios.get(`/api/wc2026/${params.date}?timezone=${encodeURIComponent(timezone)}`);
        return response.data
  
      },
      errorElement: <PageNotFoundPage/>
    },{ 
      path: "/nfl/:date", element: <NFLHomePage />,
      loader: async function({ params, request }){
        const url = new URL(request.url);
        const timezone = url.searchParams.get('tz' || 'America/Los_Angeles')
        const response  = await axios.get(`/api/nfl/${params.date}?timezone=${encodeURIComponent(timezone)}`);
        return response.data
  
      },errorElement: <PageNotFoundPage/>
    },{ 
      path: "/nba/:date", element: <NBAHomePage />,
      loader: async function({ params, request }){
        const url = new URL(request.url);
        const timezone = url.searchParams.get('tz' || 'America/Los_Angeles');
        const response  = await axios.get(`/api/nba/${params.date}?timezone=${encodeURIComponent(timezone)}`);
        return response.data
  
      },errorElement: <PageNotFoundPage/>
    }]
  }
];


const router = createBrowserRouter(routes);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
